jQuery(document).ready(function() {
  const Form = {
    init: function() {
      Form.steps = jQuery(".form-step");
      Form.stepCount = Form.steps.length;
      Form.currentStep = 0;
      Form.applicantName = jQuery("#applicant-name");
      Form.applicantEmail = jQuery("#applicant-email");
      Form.applicantPhone = jQuery("#applicant-phone");
      Form.nextButton = jQuery(".form-button--next");
      Form.prevButton = jQuery(".form-button--back");
      Form.bindings();
    },

    bindings: function() {
      Form.nextButton.click(function(e) {
        e.preventDefault();
        Form.next();
      });

      Form.prevButton.click(function(e) {
        e.preventDefault();
        Form.back();
      });
    },

    next: function() {
      if (
        !Form.applicantName.val() ||
        !Form.applicantEmail.val() ||
        !Form.applicantPhone.val() ||
        !Form.validateEmail(Form.applicantEmail.val())
      ) {
        return false;
      }

      Form.steps
        .filter(":eq(" + Form.currentStep + ")")
        .stop()
        .fadeOut("fast", function() {
          if (Form.currentStep < Form.stepCount) {
            Form.currentStep++;
          }
          Form.steps
            .filter(":eq(" + Form.currentStep + ")")
            .stop()
            .fadeIn("fast");
        });
    },

    back: function() {
      Form.steps
        .filter(":eq(" + Form.currentStep + ")")
        .stop()
        .fadeOut("fast", function() {
          if (Form.currentStep > 0) {
            Form.currentStep--;
          }
          Form.steps
            .filter(":eq(" + Form.currentStep + ")")
            .stop()
            .fadeIn("fast");
        });
    },

    validateEmail: function(email) {
      var re = /\S+@\S+\.\S+/;
      console.log(re.test(email));
      return re.test(email);
    }
  };

  Form.init();
});
